import Vue from 'vue'

/** 全局路由进度条状态（供 App.vue 显示固定条，避免 nprogress 被遮挡或同帧结束） */
export const routeProgressState = Vue.observable({
  active: false,
})

let startedAt = 0
const MIN_MS = 500

export function startRouteProgress() {
  startedAt = Date.now()
  routeProgressState.active = true
}

export function finishRouteProgress() {
  const elapsed = Date.now() - startedAt
  const wait = Math.max(0, MIN_MS - elapsed)
  setTimeout(() => {
    routeProgressState.active = false
  }, wait)
}
